// internal modules
import { updateFilter } from 'shared/search/action-creators'

import searchifyActionTypes from 'shared/search/searchify/action-types'

// accounts page default filters
import {
    userFormSubmitBills,
    userFormSubmitDocuments,
    userFormSubmitPersons,
    userFormSubmitStaffers,
    userFormSubmitSupporters,
    userFormSubmitNotes,
    userFormSubmitEvents,
    userFormSubmitVotes,
    userFormSubmitAmendments,
    userFormSubmitPublicOrganizations,
    userFormSubmitAttachments,
    userFormSubmitAlerts,
    userFormSubmitArticles,
    userFormSubmitPressContacts,
} from 'accounts/account-action-creators'
import accountActionTypes from 'accounts/account-action-types'

// campaign form
import { campaignSubmitSearchify } from 'campaign/campaign-action-creators'
import campaignActionTypes from 'shared/campaign/campaign-action-types'

// outbox
import { submitSearchifyFromOutbox } from 'outbox/action-creators'
import outboxActionTypes from 'shared/outbox/action-types'

// download center
import profileDownloadCenterActionCreators from 'downloads/profile-download-center-action-creators'
import profileDownloadCenterActionTypes from 'downloads/profile-download-center-action-types'

// sheets
import { sheetFormSubmitSearchify } from 'sheets/sheet-action-creators'
import { sheetColumnSubmitSearchify, sheetCustomDataColumnSubmitSearchify } from 'sheets/column-form-action-creators'
import sheetActionTypes from 'sheets/sheet-action-types'

// tracking dashboards
import TrackingDashboardTypes from "shared/profiles/tracking_dashboard/tracking-dashboard-profile-action-types"
import { trackingDashboardFormChangeSearchify } from "projects-new/tracking_dashboards/form-action-creators"

// issues
import { submitNewList, editNewList } from 'projects-new/issue-management/action-types'
import { createNewList, changeNewList } from 'projects-new/issue-management/action-creators/lists-page-action-creators'

// dashboards
import { widgetEditFormSubmitSearchifyFunc } from "app/static/frontend/dashboards/action-creators/widgetEditFormActionCreators"
import DashboardActionTypes from "app/static/frontend/dashboards/action-types"

// pac
import { createSpecialForm3X } from "app/static/frontend/pac/action-creators/filings-form-action-creators"
import { CREATE_SPECIAL_FORM_3X } from "shared/pac/types"

// this is the function for handling submissions for Selects in search
export function selectSubmitSearchify({ searchifyFilters, uniqueFlvIdToEdit, uniqueFilterIdToEdit }) {
    return (dispatch, getState) => {
        // apply this new filter to the previous scene!
        dispatch(updateFilter(uniqueFilterIdToEdit, uniqueFlvIdToEdit, JSON.stringify(searchifyFilters), true))
    }
}

// add new Searchify functions here
const unprocessedSubmitSearchifyFunctions = {
    // search!
    [searchifyActionTypes.SELECT_SUBMIT_SEARCHIFY]: selectSubmitSearchify,
    // campaign form
    [campaignActionTypes.CAMPAIGN_SUBMIT_SEARCHIFY]: campaignSubmitSearchify,
    // outbox
    [outboxActionTypes.OUTBOX_SUBMIT_SEARCHIFY]: submitSearchifyFromOutbox,
    // pdf downloads
    [profileDownloadCenterActionTypes.PDF_BATCH_SELECTOR_SUBMIT_SEARCHIFY]: profileDownloadCenterActionCreators.submitSearchifyFromBatchSelector,
    [profileDownloadCenterActionTypes.PDF_SINGLE_OBJECT]: profileDownloadCenterActionCreators.submitSearchifyFromPDFSingleObject,
    [profileDownloadCenterActionTypes.SEARCHIFY_SUBMIT_ELEMENT_FILTER]: profileDownloadCenterActionCreators.searchifySubmitElementFilter,
    [profileDownloadCenterActionTypes.PDF_STATISTICS_SUBMIT]: profileDownloadCenterActionCreators.submitSearchifyFromPDFStatistics,
    // account page default filters
    [accountActionTypes.USER_FORM_BILL_SUBMIT_SEARCHIFY]: userFormSubmitBills,
    [accountActionTypes.USER_FORM_DOCUMENT_SUBMIT_SEARCHIFY]: userFormSubmitDocuments,
    [accountActionTypes.USER_FORM_PERSON_SUBMIT_SEARCHIFY]: userFormSubmitPersons,
    [accountActionTypes.USER_FORM_STAFFER_SUBMIT_SEARCHIFY]: userFormSubmitStaffers,
    [accountActionTypes.USER_FORM_SUPPORTER_SUBMIT_SEARCHIFY]: userFormSubmitSupporters,
    [accountActionTypes.USER_FORM_NOTE_SUBMIT_SEARCHIFY]: userFormSubmitNotes,
    [accountActionTypes.USER_FORM_EVENT_SUBMIT_SEARCHIFY]: userFormSubmitEvents,
    [accountActionTypes.USER_FORM_VOTE_SUBMIT_SEARCHIFY]: userFormSubmitVotes,
    [accountActionTypes.USER_FORM_AMENDMENT_SUBMIT_SEARCHIFY]: userFormSubmitAmendments,
    [accountActionTypes.USER_FORM_PUBLIC_ORGANIZATION_SUBMIT_SEARCHIFY]: userFormSubmitPublicOrganizations,
    [accountActionTypes.USER_FORM_ATTACHMENT_SUBMIT_SEARCHIFY]: userFormSubmitAttachments,
    [accountActionTypes.USER_FORM_ALERT_SUBMIT_SEARCHIFY]: userFormSubmitAlerts,
    [accountActionTypes.USER_FORM_ARTICLE_SUBMIT_SEARCHIFY]: userFormSubmitArticles,
    [accountActionTypes.USER_FORM_PRESS_CONTACT_SUBMIT_SEARCHIFY]: userFormSubmitPressContacts,
    // sheets
    [sheetActionTypes.SHEET_FORM_SUBMIT_SEARCHIFY]: sheetFormSubmitSearchify,
    [sheetActionTypes.SHEET_COLUMN_SUBMIT_SEARCHIFY]: sheetColumnSubmitSearchify,
    [sheetActionTypes.SHEET_CUSTOM_DATA_COLUMN_SUBMIT_SEARCHIFY]: sheetCustomDataColumnSubmitSearchify,
    // tracking dashboards
    [TrackingDashboardTypes.TRACKING_DASHBOARD_FORM_SUBMIT_SEARCHIFY]: trackingDashboardFormChangeSearchify,
    // issues
    [submitNewList.start]: createNewList,
    [editNewList.start]: changeNewList,
    // dashboards
    [DashboardActionTypes.WIDGET_EDIT_FORM_SUBMIT_SEARCHIFY_FUNC]: widgetEditFormSubmitSearchifyFunc,
    // pac
    [CREATE_SPECIAL_FORM_3X]: createSpecialForm3X
}

export default unprocessedSubmitSearchifyFunctions
